// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header__W-aFy","testimonial":"styles__testimonial__2gR6a","clientImage":"styles__clientImage__1l05V","description":"styles__description__2u0kJ","clientInfo":"styles__clientInfo__3d3jn","seeWork":"styles__seeWork__gRuJG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupDesigners/styles.scss
// module id = 413
// module chunks = 0